import type { JourneysModuleOptions } from '@common/types/config/Modules'
import { useModule } from './useModule'

export function useModuleOptionsJourneys(): JourneysModuleOptions {
	const module = useModule()
	if (module.module !== 'journeys')
		throw new Error(`useModuleOptionsJourneys in ${module.module}`)
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
	let moduleOptions = module.options as JourneysModuleOptions | undefined
	if (!moduleOptions)
		moduleOptions = {
			transports: [],
			defaultTransports: [],
			bikes: [],
			defaultBike: [],
			bikeSpeeds: [],
			defaultBikeSpeed: null,
			walkSpeeds: ['slow'],
			defaultWalkSpeed: 'slow',
			hasPmr: true,
		}
	return moduleOptions
}
